(() => {
  if (window.lboxPhotoDialogsReady) return;
  window.lboxPhotoDialogsReady = true;
  let lastTrigger = null;
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-lbox-photo-open]');
    if (trigger) {
      const dialog = document.querySelector(`[data-lbox-photo-dialog="${trigger.dataset.lboxPhotoOpen}"]`);
      if (!dialog) return;
      lastTrigger = trigger;
      dialog.showModal();
      return;
    }
    const close = event.target.closest('[data-lbox-photo-close]');
    if (close) close.closest('dialog')?.close();
  });
  document.querySelectorAll('[data-lbox-photo-dialog]').forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (lastTrigger?.isConnected) lastTrigger.focus();
      lastTrigger = null;
    });
  });
})();
